import httpClient from '../http'
import { APP_CONNECTION_CONFIG_FILE } from '@/enviroment/app'
import { Store, DESIGN } from '@/store'

let _connectionsCache

const _getApi = async (connection = {}) => {
  try {
    require(`./${connection.type}`)
    const loadApi = () => import(`./${connection.type}`)
    const apiLoaded = await loadApi()
    return apiLoaded.default
  } catch (ex) {
    throw new Error(`Not defined API for the type '${connection.type}'`)
  }
}
const _addApiMethods = async (connection = {}) => {
  const api = await _getApi(connection)
  if (api.validateFields && api.validateFields(connection)) {
    return { ...connection, ...api }
  } else {
    return Promise.reject(new Error(`Imposible ValidateFields to API type '${connection.type}'`))
  }
}
const _evalConnections = (connections = []) => {
  return connections.map((conn) => {
    Object.keys(conn).forEach((key) => {
      try { conn[key] = new Function(`return ${conn[key]}`)() } catch (e) {}
    })
    return conn
  })
}
const _loadConnections = async () => {
  if (window.PLKDesign) {
    return Store.getters[DESIGN.GETTERS.GET_CONNECTIONS]()
  } else {
    try {
      const response = await httpClient({
        method: 'get',
        url: APP_CONNECTION_CONFIG_FILE
      })
      _connectionsCache = _evalConnections(response.data.connections)
      return _connectionsCache
    } catch (e) {
      console.error(e)
      return Promise.reject(new Error(`Imposible obtain ${APP_CONNECTION_CONFIG_FILE}`))
    }
  }
}
const _getConnections = async () => {
  if (_connectionsCache) {
    return _connectionsCache
  }
  return _loadConnections()
}
const getConnection = async (id) => {
  const connections = await _getConnections()
  let connection = connections.find(conn => conn.id === id)
  if (connection) {
    return _addApiMethods(connection)
  } else {
    return Promise.reject(new Error(`Not connection view with id '${id}'`))
  }
}
const getConnectionsByType = async (type) => {
  const connections = await _getConnections()
  const connsWithApis = await Promise.all(connections.filter(conn => conn.type === type).map((conn) => _addApiMethods(conn)))
  return connsWithApis
}
const getConnections = async () => {
  const connections = await _getConnections()
  return connections
}

export const TYPE = {
  PLAKA: 'plaka',
  AUDIT: 'audit'
}

export default {
  TYPE,
  getConnection,
  getConnectionsByType,
  getConnections
}
